import angular from 'angular';
import '../core.module';

export const GLOBAL_SEARCH_MIN_LENGTH = 2;
export const GLOBAL_SEARCH_PAGE_SIZE = 5;

export function toContactResult(record) {
  const label = record.name || record.phone || record.email || 'Contato sem nome';
  return {
    id: `contact:${record.id}`,
    kind: 'record',
    group: 'contacts',
    state: 'app.contacts',
    params: { search: record.phone || record.email || record.name || '' },
    label,
    icon: 'user',
    module: 'Contatos',
    description: [record.phone, record.email, record.company_name]
      .filter((value) => value && value !== label)
      .join(' · '),
    keywords: []
  };
}

class GlobalSearchService {
  constructor($http, $q, API_BASE_URL, CommandCatalogService) {
    this.$http = $http;
    this.$q = $q;
    this.API_BASE_URL = API_BASE_URL;
    this.CommandCatalogService = CommandCatalogService;
    this.sources = [
      {
        id: 'contacts',
        label: 'Contatos',
        state: 'app.contacts',
        fetch: (term, timeout) => this.searchContacts(term, timeout)
      }
    ];
  }

  availableSources() {
    return this.sources.filter((source) => this.CommandCatalogService.canOpen(source.state));
  }

  searchContacts(term, timeout) {
    return this.$http
      .get(`${this.API_BASE_URL}/contacts`, {
        params: { search: term, page: 1, pageSize: GLOBAL_SEARCH_PAGE_SIZE },
        timeout,
        silentErrors: true
      })
      .then((response) => ((response.data && response.data.items) || []).map(toContactResult));
  }

  search(term, timeout) {
    const sources = this.availableSources();
    return this.$q.all(
      sources.map((source) =>
        source.fetch(term, timeout).then((items) => ({
          id: source.id,
          label: source.label,
          items
        }))
      )
    );
  }
}

GlobalSearchService.$inject = ['$http', '$q', 'API_BASE_URL', 'CommandCatalogService'];

angular.module('app.core').service('GlobalSearchService', GlobalSearchService);

export default GlobalSearchService;
